import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ComponentProps } from "react";

import { THEME_STORAGE_KEY } from "@bindery/ui/lib/theme-boot";

type ThemeProviderProps = Omit<
  ComponentProps<typeof NextThemesProvider>,
  "attribute" | "storageKey"
>;

// attribute and storageKey are fixed: THEME_BOOT_SCRIPT reads the same key and
// sets the same classes before first paint, and the two must agree.
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      {...props}
      attribute="class"
      storageKey={THEME_STORAGE_KEY}
    >
      {children}
    </NextThemesProvider>
  );
}
